var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 15.72,
    viewBox: "0 0 24 15.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.94,1h0A12.3,12.3,0,0,0,12,0,12.37,12.37,0,0,0,7.06,1h0A13.53,13.53,0,0,0,2.42,4.13,12.73,12.73,0,0,0,.09,7.43.78.78,0,0,0,0,7.85a.91.91,0,0,0,.1.43,12.86,12.86,0,0,0,2.32,3.3,13.38,13.38,0,0,0,6.7,3.8l0,0a13.6,13.6,0,0,0,2.85.31,12.7,12.7,0,0,0,2.61-.26,11.4,11.4,0,0,0,1.9-.53,13.15,13.15,0,0,0,4-2.32A12.79,12.79,0,0,0,23.9,8.28,1,1,0,0,0,24,7.66a1.42,1.42,0,0,0-.07-.22h0l-.09-.17,0-.08L23.7,7V7A12.68,12.68,0,0,0,21,3.54h0A13.58,13.58,0,0,0,16.94,1ZM12,4.61A3.25,3.25,0,1,1,8.75,7.85,3.24,3.24,0,0,1,12,4.61Zm0-1.82A5.07,5.07,0,1,1,6.91,7.85,5.06,5.06,0,0,1,12,2.79h0Z",
    fill: "#41319C",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.de0e9cedcf907f81467ba87c6f790c44.svg";
export { ForwardRef as ReactComponent };